import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DirectorLandingPageComponent } from './pages/director-landing-page/director-landing-page.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { LoginComponent } from './pages/login/login.component';
import { MatchCongratulationsComponent } from './pages/match-congratulations/match-congratulations.component';
import { AuthGuard } from './shared/services/auth-guard';

const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
  },  
  {
    path: 'login',
    component: LoginComponent,
  },  
  {
    path: 'landing-page',
    component: LandingPageComponent,
  },
  {
    path: 'director-landing-page',
    component: DirectorLandingPageComponent,
    canActivate: [AuthGuard]
  },    
  {
      path: 'score-tracker',
      loadChildren: () => import('./pages/score-tracker-container/score-tracker-container.module').then(m => m.ScoreTrackerContainerModule)
  },  
  {
      path: 'match-congratulations',
      component: MatchCongratulationsComponent
  },  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
